import confetti from 'canvas-confetti';

/**
 * Confetti Helper Utility
 * Provides easy-to-use functions for confetti animations
 */

/**
 * Create a small confetti blast
 * @param {Object} options - Custom options for the confetti
 */
const smallBlast = (options = {}) => {
  confetti({
    particleCount: 50,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA'],
    ...options
  });
};

/**
 * Create a medium confetti blast
 * @param {Object} options - Custom options for the confetti
 */
const mediumBlast = (options = {}) => {
  confetti({
    particleCount: 100,
    spread: 90,
    origin: { y: 0.6 },
    colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA'],
    ...options
  });
};

/**
 * Create a large celebratory confetti blast
 * @param {Object} options - Custom options for the confetti
 */
const largeBlast = (options = {}) => {
  // First blast from bottom center
  confetti({
    particleCount: 150,
    spread: 100,
    origin: { y: 0.7 },
    colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA'],
    ...options
  });
  
  // Additional smaller blasts from left and right after a short delay
  setTimeout(() => {
    confetti({
      particleCount: 50,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.7 },
      colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA'],
    });
    
    confetti({
      particleCount: 50,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.7 },
      colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA'],
    });
  }, 150);
};

/**
 * Create a realistic confetti cannon effect that shoots upward
 * @param {Object} options - Custom options for the confetti
 */
const upwardCannon = (options = {}) => {
  const defaults = {
    particleCount: 80,
    startVelocity: 30,
    spread: 50,
    ticks: 60,
    gravity: 0.8,
    origin: { x: 0.5, y: 0.9 },
    colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA']
  };
  
  confetti({
    ...defaults,
    ...options
  });
};

/**
 * Create purchase celebration effect with multiple confetti bursts
 * Perfect for checkout success, purchase completions, etc.
 */
const purchaseCelebration = () => {
  // Initial burst from bottom center
  upwardCannon();
  
  // After a delay, add some side bursts for more dynamic feel
  setTimeout(() => {
    confetti({
      particleCount: 40,
      startVelocity: 25,
      angle: 60,
      spread: 40,
      origin: { x: 0.1, y: 0.8 },
      colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA']
    });
    
    confetti({
      particleCount: 40,
      startVelocity: 25,
      angle: 120,
      spread: 40,
      origin: { x: 0.9, y: 0.8 },
      colors: ['#00998C', '#53A5F4', '#FFE099', '#FAFAFA']
    });
  }, 250);
};

export default {
  smallBlast,
  mediumBlast,
  largeBlast,
  upwardCannon,
  purchaseCelebration
}; 